import CoordinationPanel from '../../features/coordination/layouts/shell';

export default function AgentsPage() {
    return <CoordinationPanel />;
}
